import React from 'react'
import { Header2, Header3, Text } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import Button from '../Button'
import { MissionStatsWrapper } from './styles'

const MISSION_COPY = "Glamsquad was built by a team of beauty pros, entrepreneurs, and engineers who believe at-home, salon-quality services should be accessible to everyone. That's why we provide inside access to the best of beauty — with pro services for every skin tone, hair type, and glam style."

const stats = [
  { id: 'customers', value: '200,000+', label: 'satisfied customers\nand happy members' },
  { id: 'appointments', value: '1,500,000', label: 'completed appointments\n(& counting!)' },
  { id: 'pros', value: '2,000+', label: 'nationwide beauty\nprofessionals' },
]

const MissionStats = () => (
  <MissionStatsWrapper aria-label="Our mission and impact">
    <Header2 as="h1" align="center" lineHeight="1.4" className="our-story-title">Our story</Header2>
    <Header3 as="h2" fontSize={36} weight={700} lineHeight="1.4" spacing={0.282} margin="0 0 24px 0" className="mission-subhead">
      Beauty where, when, and exactly how you want it
    </Header3>
    <Text fontSize={32} lineHeight="1.38" spacing={0.32} className="mission-copy">
      {MISSION_COPY}
    </Text>
    <div className="stats-row">
      {stats.map((s) => (
        <div className="stat" key={s.id}>
          <Header2 color={gsColors.cobalt} className="stat-value">{s.value}</Header2>
          <Text fontSize={21} weight={600} lineHeight="28px" spacing={0.21} className="stat-label">
            {s.label}
          </Text>
        </div>
      ))}
    </div>
    <div className="cta-block">
      <Header2 align="center" margin="0">Ready to get glowing?</Header2>
      <Button
        color={gsColors.cobalt}
        path="book"
        className="cta-button"
      >
        Book Glam
      </Button>
    </div>
  </MissionStatsWrapper>
)

export default MissionStats
